import Button from 'components/Button';
import BaseModal from 'components/Modals/BaseModal/BaseModal';
import CandidateStatus from 'core/enums/candidateStatus';
import Candidate from 'core/models/candidate';
import { differenceInDays } from 'date-fns';
import Premium from 'images/whiteIcons/Premium.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSessionStore } from 'stores/session';
import { SDaysRemaining, SMessage, SPremiumIcon, SPremiumInline } from './styles';

const TrialReminderModal: FC = () => {
    const user = useSessionStore((s) => s.user) as Candidate | null;
    const trialModalVisible = useSessionStore((s) => s.trialModalVisible);
    const closeModal = useSessionStore((s) => s.closeTrialModal);
    const { t } = useTranslation();
    const shouldShow = Boolean(user && user.isB2C && user.status === CandidateStatus.InTrialPeriod && !user.hasPaid);
    const isOpen = trialModalVisible && shouldShow;
    const history = useHistory();

    const daysRemaining = user && user.trialEndDate ? differenceInDays(new Date(user.trialEndDate), new Date()) : 0;

    const handleSubscribe = () => {
        closeModal();
        history.push('/ask-subscription');
    };

    if (!isOpen) {
        return null;
    }

    return (
        <BaseModal
            closeModal={closeModal}
            image={
                <SPremiumIcon>
                    <Premium />
                </SPremiumIcon>
            }
            title={t('trial-reminder-modal.title')}
        >
            <SMessage>
                {t('trial-reminder-modal.message-part1')}
                <SDaysRemaining>{daysRemaining}</SDaysRemaining>
                {t('trial-reminder-modal.message-part2')}
                <br />
                <br />
                {t('trial-reminder-modal.message-part3')}
                <br />
                {t('trial-reminder-modal.message-part4')} {t('trial-reminder-modal.message-part5')}
                <SPremiumInline>
                    <Premium />
                </SPremiumInline>
                {t('trial-reminder-modal.message-part6')}
            </SMessage>
            <BaseModal.BottomActions>
                <Button onClick={closeModal} variant="outlined">
                    {t('trial-reminder-modal.close')}
                </Button>
                <Button onClick={handleSubscribe} variant="plain">
                    {t('trial-reminder-modal.subscribe')}
                </Button>
            </BaseModal.BottomActions>
        </BaseModal>
    );
};

export default TrialReminderModal;
